import React, { Component } from 'react';
import { getUser} from '../Actions/UserActions';


import { connect } from 'react-redux';

import NavBar2 from "./NavBar2";
import SiteFoot from "../Components/SiteFoot";

class about extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            width: window.innerWidth,
            password: '',
            error: '',

        };
    }
    componentWillMount() {

        window.addEventListener('resize', this.handleWindowSizeChange);
    }

// make sure to remove the listener
// when the component is not mounted anymore
    componentWillUnmount() {
        window.removeEventListener('resize', this.handleWindowSizeChange);
    }
    handleWindowSizeChange = () => {
        this.setState({ width: window.innerWidth });
    };











    render() {

var lang
        if(this.props.lang==="zh"||this.props.lang==="zh-hk"||this.props.lang==="zh-cn"||this.props.lang==="zh-sg"||this.props.lang==="zh-tw"|| this.props.lang==="zh-HK"||this.props.lang==="zh-CN"||this.props.lang==="zh-SG"||this.props.lang==="zh-TW"){
            lang= "zh"
        }else{
            lang="en"
        }
       // console.log("-about-"+this.state.lang+"-about", this.props.lang)

        return (
            <div style={{ height: "100%",}}>



            <div  style={{backgroundColor:"white", width: "100%", display: "flex", top: "0", position:"fixed", left: "0px",
                zIndex: "500",  borderStyle: "solid",  borderColor: "FireBrick", borderWidth: "0px 0px 2px 0px"}}>


                <NavBar2/>


            </div>


            {this.state.width<500 &&<div style={{height: "16vw",}} ></div>}
            {this.state.width>=500 &&<div style={{height: "10vw", }} ></div>}

            {lang==="en" &&  <div>
            <div style={{width: "90%", margin: "auto", display: "block", padding: "0px", fontFamily:"Open Sans, sans-serif"}} >
                <div style={{width: "50%", maxWidth:"50%", verticalAlign:"top", minWidth:"20em", display: "inline-block", backgroundColor:"white", padding: "30px",}} >

                    <span style={{fontSize: "1.5em", fontWeight: "bold"}}><h2>About the Firm</h2></span><p/>
                    <span style={{fontSize: ".8em"}}>Founded by an Ivy-League-educated and Biglaw-trained attorney, the Morrow Firm specializes in business and intellectual property law and serves business and individual clients. The Morrow Firm is also one of the very few boutique law firms in the United States that has a robust China practice.</span><p/>

                    <span style={{fontSize: ".8em"}}>Why us?</span><p/>
                    ​
                    <span style={{fontSize: ".9em", fontWeight: "bold",  color: "FireBrick",}}>Creative.</span><br/>
                    <span style={{fontSize: ".8em"}}>We think outside of the box. We find the best way to tell your story—whether to a judge, a jury, or your opponent. We deliver creative solutions to your legal issues, and offer flexible fee arrangements to align our interests.</span><p/>
                    <span style={{fontSize: ".9em", fontWeight: "bold",  color: "FireBrick",}}>Tenacious.</span><br/>
                    <span style={{fontSize: ".8em"}}>Innovative strategy and key evidence make your case. We delve deep into the facts of each case to devise winning legal strategies, and leave no stone unturned until we uncover the smoking gun.  </span><p/>
                    <span style={{fontSize: ".9em", fontWeight: "bold",  color: "FireBrick",}}>Results-driven.</span><br/>
                    <span style={{fontSize: ".8em"}}> Your goal dictates our mission. At every step of the way, we advise you with the big picture in mind. Whether it is in your best interest to resolve a dispute efficiently and discreetly or go to trial full speed ahead, we are ready to fight for the best results for you. </span><p/>

                </div>
                <div style={{width: "49%", maxWidth:"50%", minWidth:"20em", height:"100%", verticalAlign:"top", display: "inline-block",  padding: "5px", top:"0px", }} ><img  alt="About the Firm"  style={{top:"0px", width: "100%", maxWidth:"450px", maxHeight:"550px"}} src="https://firebasestorage.googleapis.com/v0/b/absite-15edf.appspot.com/o/about.jpg?alt=media&token=3730f4c3-fcb7-4a22-934d-3513b4bb5cfd"/>

                </div>
            </div>
</div>}

            {lang==="zh" &&  <div>
                <div style={{width: "90%", margin: "auto", display: "block", padding: "0px", fontFamily:"Open Sans, sans-serif"}} >
                    <div style={{width: "50%", maxWidth:"50%", verticalAlign:"top", minWidth:"20em", display: "inline-block", backgroundColor:"white", padding: "30px",}} >

                        <span style={{fontSize: "1.5em", fontWeight: "bold"}}>关于我们</span><p/>
                        <span style={{fontSize: ".8em"}}>由拥有常青藤法学院法律博士学位及美国顶尖律所近十年执业经验的李馨霖律师创立，美国沫若律师事务所专注于商业和知识产权法并致力服务公司和个人客户。美国沫若律师事务所也是美国极少数具有中国业务的精品律师事务所之一。</span><p/>

                        <span style={{fontSize: ".8em"}}>为什么选我们？</span><p/>
                        ​
                        <span style={{fontSize: ".9em", fontWeight: "bold",  color: "FireBrick",}}>创见</span><br/>
                        <span style={{fontSize: ".8em"}}>我们思路开阔，拒绝墨守成规。无论是对法官，陪审团还是您的对手，我们会找到倾诉您的故事的最佳方式。 我们为您的法律问题提供创新的解决方案，并提供灵活的费用安排以保证我们和您的利益一致。 </span><p/>
                        <span style={{fontSize: ".9em", fontWeight: "bold",  color: "FireBrick",}}>专注</span><br/>
                        <span style={{fontSize: ".8em"}}>每场诉讼的输赢最终都取决于是否有创新的法律战略和关键的事实证据。 我们深入研究每个案件的事实，以制定胜出的法律策略，并且不遗余力的挖掘制胜证据。  </span><p/>
                        <span style={{fontSize: ".9em", fontWeight: "bold",  color: "FireBrick",}}>成效</span><br/>
                        <span style={{fontSize: ".8em"}}>您的目标决定我们的使命。 在每一步，我们都会为您提供全面的建议。 为了您的最佳利益，不管是需要高效的解决争议还是全速前进到庭审，我们准备好为您争取最佳结果。 </span><p/>

                    </div>
                    <div style={{width: "49%", maxWidth:"50%", minWidth:"20em", height:"100%", verticalAlign:"top", display: "inline-block",  padding: "5px", top:"0px", }} ><img alt="关于我们"  style={{top:"0px", width: "100%", maxWidth:"450px", maxHeight:"550px"}} src="https://firebasestorage.googleapis.com/v0/b/absite-15edf.appspot.com/o/about.jpg?alt=media&token=3730f4c3-fcb7-4a22-934d-3513b4bb5cfd"/>

                    </div>
                </div>
            </div>}




            <SiteFoot lang={lang}/>
            </div>


        );
    }
}

function mapStateToProps(state, ownProps) {
    return { user: state.user, admin: state.admin, lang: state.lang };
}

export default connect(mapStateToProps, { getUser })(about);



// WEBPACK FOOTER //
// ./src/Containers/about.js